import React from 'react'
import styled from 'styled-components'

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: ${({ theme }) => theme.colors.coolGray.cool150};
  border-radius: 8px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.coolGray.cool300};
  border-width: 1px;
  margin-bottom: 20px;
  padding: 0.75rem;
`

const MessageIndicator = styled.span`
  height: 24px;
`

const Message = styled.span`
  font-weight: bold;
  margin: 1px 0 0 10px;
`

interface ItemSelectionIndicatorMessageProps {
  children: React.ReactNode
  message: string
}

const ItemSelectionIndicatorMessage: React.FC<ItemSelectionIndicatorMessageProps> = ({
  children,
  message,
}) => (
  <MessageWrapper>
    <MessageIndicator>{children}</MessageIndicator>
    <Message>{message}</Message>
  </MessageWrapper>
)

export default ItemSelectionIndicatorMessage
